import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {CrmSyncSourcesEnum, mapCrmSyncSourceToIntegrationType} from '../../../../models/api/crmSyncModel';
import {
  signInToIntegrationAccountAction,
  signOutOfIntegrationAsyncAction,
} from '../../../../store/data/integrations/integrationsActions';
import {getIsUserGlobalAdmin} from '../../../../store/data/teammates/teammatesSelectors';
import {computeCrmSyncSourceDisplayName} from './crmSyncHelpers';
import {CrmSyncStepOne} from './crmSyncStepOne';

interface CrmSyncStepOneContainerProps {
  crmSyncSource: CrmSyncSourcesEnum;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isAdmin: getIsUserGlobalAdmin,
}));

const mapDispatchToProps = makeMapDispatchToProps<CrmSyncStepOneContainerProps>()(({crmSyncSource}) => {
  const integrationType = mapCrmSyncSourceToIntegrationType(crmSyncSource);

  return {
    signOutOfIntegrationAsync: () => signOutOfIntegrationAsyncAction(integrationType),
    signInToIntegrationAccount: (shouldUseTestEnv: boolean) => {
      const crmSyncSourceName = computeCrmSyncSourceDisplayName(crmSyncSource);
      // For salesforce we need to press shift to login to the test env. For hubspot we should test with our personal accounts.
      const hasTestEnvOption = crmSyncSource === CrmSyncSourcesEnum.HUBSPOT ? false : shouldUseTestEnv;
      if (integrationType) {
        return signInToIntegrationAccountAction(integrationType, crmSyncSourceName, hasTestEnvOption);
      }
      return undefined;
    },
  };
});

export const CrmSyncStepOneContainer = connect(mapStateToProps, mapDispatchToProps)(CrmSyncStepOne);
